module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_9005.c5cb0647.png";